import { makeStyles } from '@material-ui/core';

export const useRedirectResultStyles = makeStyles((theme) => {
  return {
    container: {
      paddingTop: '25vh',
    },
    container1: {
      paddingTop: '20px',
      width: '48%',
    },
    container2: {
      paddingTop: '20px',
    },
    container3: {
      paddingTop: '25vh',
    },
    link: {
      color: theme.palette.primary.main,
    },
    subtitle: {
      fontSize: '12px',
      lineHeight: '20px',
    },
    subtitle2: {
      color: '#999999',
      fontSize: '20px',
      lineHeight: '30px',
    },
    title: {
      fontWeight: 'bold',
      lineHeight: '30px',
    },
  };
});

export const usePackagePlanStyles = makeStyles((theme) => {
  return {
    container: {
      height: '100%',
      width: '100%',
    },
    container1: {
      color: '#388E3C',
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '25px',
      paddingTop: '30px',
      width: '60%',
    },
    container2: {
      color: '#999999',
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '30px',
      paddingTop: '30px',
    },
    packageContainer: {
      paddingTop: '58px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: 10,
      },
    },
    packageDescription: {
      color: '#172B4D',
      display: 'inline',
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '26px',
    },
    packageDescription2: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '26px',
    },
    packageDescription2Container: {
      paddingTop: '8px',
    },
    packageDescriptionContainer: {
      paddingTop: '20px',
    },
    packageName: {
      color: '#172B4D',
      fontSize: '20px',
      fontWeight: 'bold',
      lineHeight: '50px',
    },
    packageOther: {
      color: '#172B4D',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px',
      paddingTop: '16px',
      width: '70%',
    },
    packageOtherContainer: {
      display: 'flex',
      justifyContent: 'center',
    },
    packagePopular: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '122%',
    },
    packagePopularHidden: {
      color: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: '122%',
      minHeight: '17px',
      visibility: 'hidden',
    },
    packagePrice: {
      color: theme.palette.primary.main,
      fontSize: '50px',
      fontWeight: '500',
      lineHeight: '60px',
    },
    packageStrong: {
      color: '#388E3C',
      display: 'inline',
      fontSize: '16px',
      fontWeight: 600,
    },
    plan: {
      padding: '24px 0',
    },
    planWithBorder: {
      padding: '24px 0',
      [theme.breakpoints.up('md')]: {
        '&:not(:last-child)': {
          borderRight: '1px solid #E7E7E7',
        },
      },
      [theme.breakpoints.down('sm')]: {
        padding: '10px 0',
      },
    },
    previousPrice: {
      color: '#B12A2A',
      fontSize: '28px',
      fontWeight: '500',
      textDecorationLine: 'line-through',
    },
    selectContainer: {
      paddingTop: '36px',
    },
    subtitle: {
      lineHeight: '22px',
      paddingTop: '12px',
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '80%',
      },
    },
    title: {
      lineHeight: '30px',
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  };
});
